import { render, staticRenderFns } from "./projectSquare.vue?vue&type=template&id=255a38d1&scoped=true"
import script from "./projectSquare.vue?vue&type=script&lang=js"
export * from "./projectSquare.vue?vue&type=script&lang=js"
import style0 from "./projectSquare.vue?vue&type=style&index=0&id=255a38d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255a38d1",
  null
  
)

export default component.exports